import css from 'styled-jsx/css';
import { MQ_LARGE, MQ_MEDIUM, MQ_MIDLARGE } from 'constants/mq';
import { pageWidth, sansSerif } from 'styles/css-constants';

export default css`
  .PageHeader {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1.5rem 1rem 1rem;
    font-family: ${sansSerif};
  }

  .PageHeader__breadcrumbs {
    position: absolute;
    top: 0.5rem;
    left: 0;
    width: 100%;
    padding: 0 1rem;
    text-align: center;
  }

  .PageHeader__description {
    font-size: var(--fontScaleNeg2);
    line-height: 1.4;
    text-align: center;
  }

  .PageHeader__image {
    display: none;
  }

  .PageHeader__title {
    margin-bottom: 0.5rem;
    font-size: var(--fontScale4);
    font-weight: normal;
    text-align: center;
  }

  @media ${MQ_MEDIUM} {
    .PageHeader__description {
      margin: 0 auto;
      max-width: ${pageWidth.medium};
    }
  }

  @media ${MQ_LARGE} {
    .PageHeader {
      margin: 0 auto;
      max-width: ${pageWidth.large};
    }

    .PageHeader__description {
      font-size: var(--fontScaleNeg1);
    }
  }

  @media ${MQ_MIDLARGE} {
    .PageHeader {
      max-width: ${pageWidth.midlarge};
    }
  }
`;
